import React from "react";
import Faqs from "../components/FaqCom/FaqFive";
import Features from "../components/Features/Features";
import Hero from "../components/Hero/Hero";
import Footer from "../components/Layout/Footer/Footer";
import LandingHeader from "../components/Layout/Header/LandingHeader/LandingHeader";
import PageLayout from "../components/Layout/PageLayout";
import Pricings from "../components/Price/PriceTwo";
import BPayDemo from "../components/Videos/BPayDemo";
import DriverUssdSection from "../components/WhyChooseUs/DriverUssdSection";

export default function LandingPage() {
  return (
    <PageLayout>
      <LandingHeader />
      <Hero />
      <div className="h-[15vh] md:h-[25vh]" />
      <BPayDemo />
      <Features />
      <DriverUssdSection />
      <Pricings />
      <Faqs />
      <Footer />
    </PageLayout>
  );
}
